import {
  arrayM5P,
  arrayM85P,
  arrayM95P,
  arrayF5P,
  arrayF85P,
  arrayF95P,
} from './arrays'
import percentiles from './percentiles'

const getERF = (x) => {
  const a1 = 0.254829592
  const a2 = -0.284496736
  const a3 = 1.421413741
  const a4 = -1.453152027
  const a5 = 1.061405429
  const p = 0.3275911
  const absX = Math.abs(x)
  const t = 1 / (1 + p * absX)
  let ret

  ret = a5
  ret *= t
  ret += a4
  ret *= t
  ret += a3
  ret *= t
  ret += a2
  ret *= t
  ret += a1
  ret *= t
  ret *= Math.exp(-1 * absX * absX)
  ret = 1 - ret

  return ret
}

const getNormSDist = (z) => {
  let sign = 1
  let ret

  if (z < 0) {
    sign = -1
  }

  ret = Math.abs(z)
  ret /= Math.SQRT2
  ret = getERF(ret)
  ret *= sign
  ret += 1
  ret /= 2

  return ret
}

const addNumberExtension = (number) => {
  let lastNumber = number.slice(-1)
  let suffix

  lastNumber = parseInt(lastNumber, 10)

  if (lastNumber === 1 && number !== 11) {
    suffix = 'st'
  } else if (lastNumber === 2 && number !== 12) {
    suffix = 'nd'
  } else if (lastNumber === 3 && number !== 13) {
    suffix = 'rd'
  } else {
    suffix = 'th'
  }

  return number + suffix
}

const getChildPercentile = (bmi, gender, ageInMonths) => {
  let childPercentile

  for (let i = 0; i < percentiles.length; i += 1) {
    if (
      percentiles[i].Sex === gender &&
      percentiles[i].Agemos === `${ageInMonths}.5`
    ) {
      const lVal = percentiles[i].L
      const mVal = percentiles[i].M
      const sVal = percentiles[i].S
      const score = ((bmi / mVal) ** lVal - 1) / (lVal * sVal)

      childPercentile = getNormSDist(score) * 100
      childPercentile = Math.round(childPercentile)
      childPercentile = addNumberExtension(childPercentile.toString())
    }
  }

  return childPercentile
}

const getChildStats = (bmi, gender, ageInMonths) => {
  // dataset starts at 24 months, reindex to match
  const age = ageInMonths - 24
  let category
  let idealBMI

  if (gender === 'm') {
    if (bmi < arrayM5P[age]) {
      category = 'Underweight'
    } else if (bmi < arrayM85P[age]) {
      category = 'Healthy'
    } else if (bmi < arrayM95P[age]) {
      category = 'Overweight'
    } else if (bmi >= arrayM95P[age]) {
      category = 'AtRisk'
    }

    idealBMI = {
      low: arrayM5P[age],
      high: arrayM85P[age],
    }
  } else {
    if (bmi < arrayF5P[age]) {
      category = 'Underweight'
    } else if (bmi < arrayF85P[age]) {
      category = 'Healthy'
    } else if (bmi < arrayF95P[age]) {
      category = 'Overweight'
    } else if (bmi >= arrayF95P[age]) {
      category = 'AtRisk'
    }

    idealBMI = {
      low: arrayF5P[age],
      high: arrayF85P[age],
    }
  }

  return {
    percentile: getChildPercentile(bmi, gender, ageInMonths),
    category,
    idealBMI,
  }
}

export default getChildStats
